import React from "react";
import { ElSearchAdvance } from "../../components/el-search-advance/ElSearchAdvance";
import { AiAssistProvider } from "../../components/ai-assist-refactored/AiAssist.context";

const SearchResultPage: React.FC = () => {
    return (
        <ElSearchAdvance />
    );
};
export default SearchResultPage;
